import styles from "./AIChatButtonNewChat.module.css";

import { Tooltip, ActionIcon } from "@mantine/core";
import IconRestart from "../../assets/restart.svg?react";

interface AIChatButtonNewChatProps {
	isReady: boolean;
	setThread: (thread: any) => void;
}

export default function AIChatButtonNewChat({ isReady, setThread }: AIChatButtonNewChatProps) {
	return (
		<Tooltip label="New chat">
			<ActionIcon
				className={styles.root}
				size="xl"
				onClick={() => setThread("")}
				disabled={!isReady}
			>
				<IconRestart />
			</ActionIcon>
		</Tooltip>
	);
}
